import React from "react";
import { Flex } from "@chakra-ui/react";
import { Button } from "newui/components/Button";
import { cn } from "utils/helpers";
import Tooltip from "newui/components/Tooltip";
import { ExternalAcceptDeclineButtonsProps } from "./types";

const deadlineTooltip =
	"Submission deadline has passed. You can no longer accept or decline the invitation.";

interface AcceptDeclineButtonsProps extends ExternalAcceptDeclineButtonsProps {
	className?: string;
}

export const AcceptDeclineButtons: React.FC<AcceptDeclineButtonsProps> = ({
	className,
	hasDeadlinePassed,
	setShowDialog,
}) => {
	return (
		<Flex
			gap={4}
			className={className}
		>
			<Tooltip
				label={hasDeadlinePassed ? deadlineTooltip : "Accept Invitation"}
			>
				<Button
					btntype="primary"
					onClick={() => setShowDialog("accept")}
					data-testid="accept-button"
					disabled={hasDeadlinePassed}
				>
					<div className="font-roboto font-semibold text-white">
						Accept Invitation
					</div>
				</Button>
			</Tooltip>

			<Tooltip
				label={hasDeadlinePassed ? deadlineTooltip : "Decline Invitation"}
			>
				<Button
					btntype="secondary"
					onClick={() => setShowDialog("decline")}
					data-testid="decline-button"
					disabled={hasDeadlinePassed}
				>
					<div
						className={cn(
							"font-roboto font-semibold",
							!hasDeadlinePassed && "text-utility-blue-dark-100"
						)}
					>
						Decline Invitation
					</div>
				</Button>
			</Tooltip>
		</Flex>
	);
};
